"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../utils/constants");
var muiFlip16 = {
    paths: [
        {
            path: 'M4,2 L4,0.941655249 C4,0.421593415 3.55194859,0 2.99924918,0 C2.71814942,0 2.45001007,0.111241611 2.26041104,0.306518027 L0.261912687,2.36485979 C-0.0873042289,2.72453372 -0.0873042289,3.2754603 0.261912687,3.63513423 L2.26041104,5.69347599 C2.63320137,6.07742923 3.26619675,6.1043242 3.67424578,5.7535476 C3.88177719,5.57514463 4,5.32283924 4,5.05833877 L4,4 L9.23529412,4 C10.7481908,4 12,5.33004726 12,7 C12,8.66995274 10.7481908,10 9.23529412,10 L5,10 C4.44771525,10 4,10.4477153 4,11 C4,11.5522847 4.44771525,12 5,12 L9.23529412,12 C11.8807767,12 14,9.74832525 14,7 C14,4.25167475 11.8807767,2 9.23529412,2 L4,2 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'Flip',
    width: 14,
    height: 12,
};
var muiFlip24 = {
    paths: [
        {
            path: 'M5.98838178,3.00372772 L12.493776,3.00372772 C16.639349,3.00372772 20,6.3615921 20,10.5037277 C20,14.6458633 16.639349,18.0037277 12.493776,18.0037277 L7.48879671,18.0037277 C6.6596821,18.0037277 5.9875519,17.3321548 5.9875519,16.5037277 C5.9875519,15.6753006 6.6596821,15.0037277 7.48879671,15.0037277 L12.493776,15.0037277 C14.9811198,15.0037277 16.9975104,12.9890091 16.9975104,10.5037277 C16.9975104,8.01844635 14.9811198,6.00372772 12.493776,6.00372772 L5.98838178,6.00372772 L5.98838178,8.0074518 C5.98838178,8.55973655 5.54029498,9.0074518 4.9875519,9.0074518 C4.74423585,9.0074518 4.5092527,8.91888675 4.32655394,8.75832194 L0.339844597,5.25460238 C-0.0751936751,4.88984599 -0.115709805,4.2579765 0.249349287,3.84328237 C0.277552864,3.81124411 0.30777975,3.78104229 0.339844597,3.7528621 L4.32655394,0.249142531 C4.74159222,-0.11561386 5.37398608,-0.0751313256 5.73904517,0.339562803 C5.89974323,0.522110069 5.98838178,0.756898376 5.98838178,1.00001267 L5.98838178,3.00372772 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'Flip',
    width: 20,
    height: 18,
};
var muiFlip = {
    base: muiFlip16,
    smIcon: muiFlip16,
    lgIcon: muiFlip24,
};
exports.muiFlip = muiFlip;
//# sourceMappingURL=flip.js.map